import * as React from "react";
import styled, { css } from "styled-components";
import { MENU_ROLES } from "../Menu/utils/constants";
import { Arrow } from "@sproutsocial/seeds-react-select";
import Icon from "@sproutsocial/seeds-react-icon";
// eslint-disable-next-line no-restricted-imports
import Menu, { MenuButton } from "../Menu";
import type { TypeListboxProps, TypeListboxButtonProps } from "./ListboxTypes";

/**
 * @deprecated Listbox is deprecated. Listbox will be removed in 2025 in favor of seeds-react-menu ecosystem. Create a plan to migrate to {@link https://github.com/sproutsocial/seeds/tree/main/seeds-react/seeds-react-menu/src | seeds-react-menu}.
 */
export const Listbox = ({
  role = MENU_ROLES.LISTBOX,
  children,
  ...rest
}: TypeListboxProps) => {
  return (
    <Menu {...rest} role={role}>
      {children}
    </Menu>
  );
};

/**
 * These styles are copied from @sproutsocial/racine/commonjs/Select/styles and applied at the root element since
 * the Listbox component doesn't render a select.
 */
export const ListboxButtonContainer = styled(MenuButton)`
  position: relative;
  width: 100%;
  border: 1px solid ${(props) => props.theme.colors.form.border.base};
  border-radius: ${(props) => props.theme.radii[500]};
  background-color: ${(props) => props.theme.colors.form.background.base};
  color: ${(props) => props.theme.colors.text.body};
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  outline: none;
  appearance: none;
  transition: border-color ${(props) => props.theme.duration.fast}
      ${(props) => props.theme.easing.ease_in},
    box-shadow ${(props) => props.theme.duration.fast}
      ${(props) => props.theme.easing.ease_in};
  font-family: ${(props) => props.theme.fontFamily};
  font-weight: ${(props) => props.theme.fontWeights.normal};
  text-align: left;
  margin: 0;
  &:active {
    transform: none;
  }

  padding: ${(props) => {
    switch (props.size) {
      case "large":
        return `${props.theme.space[400]} ${props.theme.space[600]} ${props.theme.space[400]} ${props.theme.space[400]}`;

      case "small":
        return `${props.theme.space[200]} ${props.theme.space[500]} ${props.theme.space[200]} ${props.theme.space[200]}`;

      case "default":
      default:
        return `${props.theme.space[300]} ${props.theme.space[500]} ${props.theme.space[300]} ${props.theme.space[300]}`;
    }
  }};
  font-size: ${(props) => {
    switch (props.size) {
      case "large":
        return props.theme.typography[300].fontSize;

      case "small":
      case "default":
      default:
        return props.theme.typography[200].fontSize;
    }
  }};

  ${(props) =>
    props.invalid &&
    css`
      border-color: ${(props) => props.theme.colors.form.border.error};
      ${Arrow} {
        color: ${(props) => props.theme.colors.icon.error};
      }
    `}
`;

/**
 * @deprecated ListboxButton is deprecated. ListboxButton will be removed in 2025 in favor of seeds-react-menu ecosystem. Create a plan to migrate to {@link https://github.com/sproutsocial/seeds/tree/main/seeds-react/seeds-react-menu/src | seeds-react-menu}.
 */
export const ListboxButton = ({
  children,
  ...restProps
}: TypeListboxButtonProps) => (
  <ListboxButtonContainer
    {...restProps}
    popoutProps={{
      placement: "bottom-start",
      ...(restProps.popoutProps || {}),
    }}
  >
    {children}
    <Arrow size={restProps.size}>
      <Icon name="chevron-down-outline" fixedWidth aria-hidden />
    </Arrow>
  </ListboxButtonContainer>
);

Listbox.Option = Listbox.Item = Menu.Item;
Listbox.Checkbox = Menu.Checkbox;
Listbox.Radio = Menu.Radio;
Listbox.Switch = Menu.Switch;
Listbox.Group = Menu.Group;
Listbox.Divider = Menu.Divider;
Listbox.FilterInput = Menu.FilterInput;

/**
 * @deprecated Listbox is deprecated. Listbox will be removed in 2025 in favor of seeds-react-menu ecosystem. Create a plan to migrate to {@link https://github.com/sproutsocial/seeds/tree/main/seeds-react/seeds-react-menu/src | seeds-react-menu}.
 */
export default Listbox;
